// @ts-nocheck
import axios from '../utils/axios';
import {
    EVENT_STATUSES,
    TICKET_API_ENDPOINT,
    MONITORING_API_ENDPOINT,
    ONLINE_FEED_SERVICE_API_ENDPOINT,
    ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT,
    ONLINE_REPORT_SERVICE_API_ENDPOINT,
} from '../config';
import { catchAsync, paramsSerializer } from '../utils/api';

const getCompetitionTypes = catchAsync(async () => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/competition-types`);
    return result.data;
});

const getSports = catchAsync(async () => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/sports`);
    return result.data;
});

const getEventTypes = catchAsync(async () => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/event-types`);
    return result.data;
});

const getCategories = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${TICKET_API_ENDPOINT}/categories?${query}`);
    return result.data;
});

const getCategoriesAndMarkets = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/categories-and-markets`, { params });
    return result.data;
});

const getMarketsForStaticLabels = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(`${TICKET_API_ENDPOINT}/market/by-sport-and-competitionType?${query}`);
    return result.data;
});

const getOutcomesByMarket = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${TICKET_API_ENDPOINT}/outcomes/by-market?${query}`);
    return result.data;
});

const getTournaments = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/tournaments`, { params });
    return result.data;
});

const getAllTournamentsAndEvents = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/events-and-league/by-category/all-league-and-events`, {
        params,
    });
    return result.data;
});

const getActiveTournamentsAndEvents = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${TICKET_API_ENDPOINT}/events-and-league/by-category?${query}`);
    return result.data;
});

//TODO this is temporary,remove after bonus presentation

const getActiveTournamentsAndEventsForBonus = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${TICKET_API_ENDPOINT}/events-and-league/by-category-bonus?${query}`);
    return result.data;
});

const getUsedTournamentsAndEvents = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/leagues-and-events/by-sport`, { params });
    return result.data;
});

const getAllEventMarkets = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${TICKET_API_ENDPOINT}/market/by-event?${query}`);
    return result.data;
});

const getUsedEventMarkets = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/markets/by-event`, { params });
    return result.data;
});

const getMbnTypes = catchAsync(async () => {
    const result = await axios.get(MONITORING_API_ENDPOINT + '/mbn');
    return result.data;
});

const getEventStatuses = catchAsync(async () => {
    const result = await axios.get(`${EVENT_STATUSES}`);
    return result.data;
});

const getMarketColumnTypes = catchAsync(async () => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/market/column-types`);

    return result.data;
});

const getTicketSubStatuses = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/properties-resource/ticket-sub-statuses`);

    return result.data;
});

const getEventDetails = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/event-details/by-eventId`, { params });

    return result.data;
});

const getMarketAndOutcomes = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/markets-and-outcomes/by-eventId`, { params });

    return result.data;
});

const getAllLeaguesBySport = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/tournaments/all/by-sport`, { params });

    return result.data;
});

const getTournamentsBySportAndCategory = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/tournaments/by-sport-and-category`, { params });

    return result.data;
});

const getDynamicMarketsBySport = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/market/by-sport`, { params });

    return result.data;
});

const getMarketSpecifiers = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/market/specifiers`, { params });

    return result.data;
});

const getEventsByKeyword = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_FEED_SERVICE_API_ENDPOINT}/events/search`, { params });

    return result.data;
});

const getActiveTournamentsByCategory = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/tournaments/active`, { params });

    return result.data;
});

const getOutcomesByEventIdAndMarketHash = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/outcomes`, { params });
    return result.data;
});

const getMarketsByEvent = catchAsync(async params => {
    const query = paramsSerializer(params);

    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/markets?${query}`);
    return result.data;
});

const getActiveEventsByTournamentId = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/event-details/active/by-tournamentId`, { params });

    return result.data;
});

const getChannelTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/channel`);

    return result.data;
});

const createAppVersion = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/app-versions`, data);

    return result.data;
});

const getAppVersions = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/app-versions`);

    return result.data;
});

const getAllBlockedCashout = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/cashout-block-template`, { params });

    return result.data;
});

const blockCashout = catchAsync(async params => {
    const result = await axios.post(`${TICKET_API_ENDPOINT}/cashout-block-template/save`, params);

    return result.data;
});

const unblockCashout = catchAsync(async (id, params, operation) => {
    const result = await axios.patch(
        `${TICKET_API_ENDPOINT}/cashout-block-template/deactivate/${id}?operation=${operation}`,
        params,
    );

    return result.data;
});

const unblockCashoutTicket = catchAsync(async params => {
    const result = await axios.patch(`${TICKET_API_ENDPOINT}/cashout-block-template/deactivate`, params);

    return result.data;
});

const getUsedTournamentsAndMarkets = catchAsync(async params => {
    const result = await axios.get(`${TICKET_API_ENDPOINT}/tournaments-and-markets`, { params });
    return result.data;
});

const updateCashoutMarkets = catchAsync(async (id, params) => {
    const result = await axios.put(`${TICKET_API_ENDPOINT}/cashout-block-template/${id}`, params);

    return result.data;
});

const GeneralService = {
    getCompetitionTypes,
    getSports,
    getEventTypes,
    getCategories,
    getCategoriesAndMarkets,
    getMarketsForStaticLabels,
    getTournaments,
    getAllTournamentsAndEvents,
    getAllLeaguesBySport,
    getTournamentsBySportAndCategory,
    getActiveTournamentsAndEvents,
    getActiveTournamentsAndEventsForBonus,
    getUsedTournamentsAndEvents,
    getAllEventMarkets,
    getUsedEventMarkets,
    getMbnTypes,
    getEventStatuses,
    getMarketColumnTypes,
    getTicketSubStatuses,
    getEventDetails,
    getMarketAndOutcomes,
    getOutcomesByMarket,
    getMarketSpecifiers,
    getDynamicMarketsBySport,
    getEventsByKeyword,
    getActiveTournamentsByCategory,
    getOutcomesByEventIdAndMarketHash,
    getMarketsByEvent,
    getActiveEventsByTournamentId,
    getChannelTypes,
    createAppVersion,
    getAppVersions,
    getAllBlockedCashout,
    blockCashout,
    unblockCashout,
    getUsedTournamentsAndMarkets,
    updateCashoutMarkets,
    unblockCashoutTicket,
};

export default GeneralService;
